// Kindly's wording and links for the shared sign-in screen: the route gate and
// a load error shown to a signed-out user say the same thing.
import { signUpUrl } from "@jkast90/kast-common/auth";
import type { SignInScreenProps } from "@jkast90/kast-common/ui";
import { startSignIn } from "./signIn";

export function signInScreen(): SignInScreenProps {
  return {
    onSignIn: startSignIn,
    signUpHref: signUpUrl(),
    detail:
      "Sign in or create an account to see your family's wishlists, memories and events.",
  };
}
